import React from 'react';

function BillLargeNormalSVG() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 2H17C19.2091 2 21 3.79086 21 6V19.5858C21 20.4767 19.9229 20.9229 19.2929 20.2929L18.6615 19.6615C18.2893 19.2893 17.6921 19.2694 17.2959 19.6161L15.317 21.3476C14.563 22.0074 13.437 22.0074 12.683 21.3476L10.7041 19.6161C10.3079 19.2694 9.71073 19.2893 9.33846 19.6615L8.70711 20.2929C8.07714 20.9229 7 20.4767 7 19.5858V12L5 2Z"
        fill="#C3C2C7"
      />
      <path d="M3 4C3 2.89543 3.89543 2 5 2C6.10457 2 7 2.89543 7 4V12H5C3.89543 12 3 11.1046 3 10V4Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 7C10 6.44772 10.4477 6 11 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H11C10.4477 8 10 7.55228 10 7Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 11C10 10.4477 10.4477 10 11 10H14C14.5523 10 15 10.4477 15 11C15 11.5523 14.5523 12 14 12H11C10.4477 12 10 11.5523 10 11Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 15C10 14.4477 10.4477 14 11 14H14C14.5523 14 15 14.4477 15 15C15 15.5523 14.5523 16 14 16H11C10.4477 16 10 15.5523 10 15Z"
      />
      <path
        d="M18 7C18 7.55228 17.5523 8 17 8C16.4477 8 16 7.55228 16 7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7Z"
        fill="white"
      />
      <path
        d="M18 11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11C16 10.4477 16.4477 10 17 10C17.5523 10 18 10.4477 18 11Z"
        fill="white"
      />
      <path
        d="M18 15C18 15.5523 17.5523 16 17 16C16.4477 16 16 15.5523 16 15C16 14.4477 16.4477 14 17 14C17.5523 14 18 14.4477 18 15Z"
        fill="white"
      />
    </svg>
  );
}

export default BillLargeNormalSVG;
